export default __webpack_public_path__ + "static/media/nodejs.290f6300.png";